import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import images from "../../assets/images";
import { getLocalization } from "../../redux/localization";

const FourthSection = () => {
  const t = useSelector(getLocalization);
  return (
    <section className="adSection4">
      <Container>
        <Row>
          <Col md={12}>
            <h2>{t.getString("Customize Your Rental Website")}</h2>
            <h3>
              {t.getString(
                "Change color & theme depending your company logo and start getting reservations from your website"
              )}
            </h3>
          </Col>
          <Col md={12}>
            <img src={images.section4} alt="Rental Manangement" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default FourthSection;
